/**
 * Thin wrapper around the browser's built-in Web Speech API
 * (window.speechSynthesis) — no external service, no API key, no data.
 */
export function isSupported() {
	return typeof window !== 'undefined' && 'speechSynthesis' in window;
}

let currentUtterances = [];
let currentIndex = -1;

export function speakChapter(verses, { onVerseStart, onEnd } = {}) {
	if (!isSupported()) return;

	stop();

	currentUtterances = verses.map((v) => {
		const utter = new SpeechSynthesisUtterance(`${v.verse}. ${v.text}`);
		utter.rate = 0.95;
		return utter;
	});
	currentIndex = -1;

	currentUtterances.forEach((utter, i) => {
		utter.onstart = () => {
			currentIndex = i;
			if (onVerseStart) onVerseStart(verses[i].verse);
		};
		if (i === currentUtterances.length - 1) {
			utter.onend = () => {
				currentIndex = -1;
				if (onEnd) onEnd();
			};
		}
	});

	currentUtterances.forEach((utter) => window.speechSynthesis.speak(utter));
}

export function pause() {
	if (isSupported()) window.speechSynthesis.pause();
}

export function resume() {
	if (isSupported()) window.speechSynthesis.resume();
}

export function stop() {
	if (isSupported()) window.speechSynthesis.cancel();
	currentUtterances = [];
	currentIndex = -1;
}

export function isSpeaking() {
	return isSupported() && window.speechSynthesis.speaking;
}

export function isPaused() {
	return isSupported() && window.speechSynthesis.paused;
}
